import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import CalendarDialog from "../../calendarDialog/CalendarDialog";
import UpperCaseText from "../../../../../utils/UpperCaseText";
import {
  FINANCE,
  FINANCE_OPTIONS,
  OFFLINEFINANCE,
} from "../../../../../common/Constants";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import checkboxStyles from "../../../../../shared/checkBox/CheckBox.module.scss";
import styles from "./FinanceOptions.module.scss";
import CalendarDialogWithOutCheckBox from "../../calendarDialog/CalenderDialogWithoutCheckBox";
import CapitalizeText from "../../../../../utils/CapitalizeText";
import HasPermissionTo from "../../../../../common/HasPermissionTo";
import LowerCaseText from "../../../../../utils/LowerCaseText";
import CustomerReservationsClient from "../../../../../shared/clients/CustomerReservationsClient";
import FileEncoder from "../../../../../utils/FileEncoder";
import UiDateUtils from "../../../../../utils/UiDateUtils";

import Error from "../../../../../imgs/error/error.png";
import { IS_BRITAIN_MARKET } from "../../../../../utils/EmpUtil";
import RegistrationNumberDialog from "./registrarionNumberDialog/RegistrationNumberDialog";
import TermsDialog from "../../../../../shared/termsDialog/TermsDialog";

const ItemDetails = ({ date, description }) => {
  return (
    <div className={styles.info}>
      {date ? (
        <span className={styles.paymentInfo}>
          {UiDateUtils.formattedDate(date)}
        </span>
      ) : (
        <span className={styles.emptyDate} />
      )}
      {description}
    </div>
  );
};

class FinanceOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openRegistrationNumberDialog: false,
      openDealerInvoiceDialog: false,
    };
    this.hasCompletedRegistrationNumber = false;
    this.hasUploadedDealerInvoice = false;
    this.hasCompletedFinanceContract = false;
    this.hasCompletedDownPayment = false;
    this.hasCompletedFinancePayment = false;
    this.eSignedDate = null;
    this.eSignedWindowDate = null;
    this.expiryDate = null;
    this.completedDate = null;
    this.canEditPaymentMethod =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "paymentMethod:write"
      );
    this.canEditRegistrationNumber =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "registrationNumber:write"
      );
  }

  handleRegistrationNumberDialog = () => {
    this.setState((prevState) => ({
      openRegistrationNumberDialog: !prevState.openRegistrationNumberDialog,
    }));
  };
  handleDealerInvoiceDialog = () => {
    this.setState((prevState) => ({
      openDealerInvoiceDialog: !prevState.openDealerInvoiceDialog,
    }));
  };
  handleConsumerDownPayment = () => {};

  checkHasCompletedPreviousActions() {
    const customerReservation = this.props.customerReservation;

    this.hasCompletedRegistrationNumber =
      customerReservation.registrationDetails &&
      customerReservation.registrationDetails.registrationNumber !== null &&
      customerReservation.registrationDetails.registrationDate !== null;
    this.hasUploadedDealerInvoice =
      customerReservation.uploadDealerInvoiceData &&
      customerReservation.uploadDealerInvoiceData.dealerActionDate !== null;
    this.hasCompletedDownPayment =
      customerReservation.downPaymentPaidData &&
      customerReservation.downPaymentPaidData.paymentDate !== null;
    this.hasCompletedFinancePayment =
      customerReservation.finalPaymentConfirmedData &&
      customerReservation.finalPaymentConfirmedData.dealerAcceptedDate !== null;
    this.financeContractData(this.props.customerReservation.paymentDescription);
  }

  financeContractData = (paymentDesc) => {
    if (LowerCaseText(this.props.paymentType) === FINANCE) {
      paymentDesc &&
        paymentDesc.length > 0 &&
        paymentDesc.forEach((item) => {
          if (UpperCaseText(item.status) === FINANCE_OPTIONS.SIGNING) {
            this.eSignedWindowDate = item.date;
            const dateArray = item.date.split("-");
            const dateObject = new Date(
              dateArray[1] + "-" + dateArray[0] + "-" + dateArray[2]
            );
            const monthDateObject = new Date(
              dateObject.setMonth(dateObject.getMonth() + 1)
            );
            const expiryDate = new Date(
              monthDateObject.setDate(monthDateObject.getDate() - 1)
            );
            const year = expiryDate.getFullYear();
            const month = (1 + expiryDate.getMonth())
              .toString()
              .padStart(2, "0");
            const day = expiryDate.getDate().toString().padStart(2, "0");
            this.expiryDate = day + "/" + month + "/" + year;
          }
          if (UpperCaseText(item.status) === FINANCE_OPTIONS.SIGNED) {
            this.eSignedDate = item.date;
          }
          if (UpperCaseText(item.status) === FINANCE_OPTIONS.COMPLETED) {
            this.completedDate = item.date;
          }
        });
      this.hasCompletedFinanceContract = this.eSignedDate !== null;
      this.hasCompletedFinancePayment = this.completedDate !== null;
    } else {
      this.hasCompletedFinanceContract =
        this.props.customerReservation.contractSignedData &&
        this.props.customerReservation.contractSignedData.dealerAcceptedDate !==
          null;
      this.hasCompletedFinancePayment =
        this.props.customerReservation.finalPaymentConfirmedData &&
        this.props.customerReservation.finalPaymentConfirmedData
          .dealerAcceptedDate !== null;
    }
  };
  hasCompletedPreviousOption = (id) => {
    let previousStep = null;
    const options = FINANCE_OPTIONS[UpperCaseText(this.props.selectedMarket)];
    options &&
      options.forEach((item) => {
        if (item.key === id) {
          if (!item.hasPrevious) {
            previousStep = false;
          } else {
            previousStep = item.previousKey;
          }
        }
      });
    switch (previousStep) {
      case true:
        return true;
      case "registrationNumber":
        return !this.hasCompletedRegistrationNumber;
      case "uploadDealerInvoice":
        return !this.hasUploadedDealerInvoice;
      case "financeContract":
        return !this.hasCompletedFinanceContract;
      case "customerDownPayment":
        return !this.hasCompletedDownPayment;
      case "financePayment":
        return !this.hasCompletedFinancePayment;
      default:
        return previousStep;
    }
  };

  uploadInvoice = (dealerId, file) => {
    const proposalNumber =
      this.props.customerReservation &&
      this.props.customerReservation.proposalNumber;

    this.props.hideOrShow(true);

    new FileEncoder().encode(file).then((data) => {
      const dealerInvoiceRequest = {
        dealerAction: "uploaddealerinvoice",
        token: this.props.user.token,
        commonIds: this.props.user.dealerId,
        userId: this.props.user.userId,
        fileName: file.name,
        fileData: data,
        dealerId: this.props.customerReservation.dealerId,
        fileType: "pdf",
        orderId: this.props.reservationId,
      };
      CustomerReservationsClient.uploadFinancialDocument(
        proposalNumber,
        dealerInvoiceRequest
      )
        .catch(() => {})
        .finally(() => {
          this.props.hideOrShow(false);
          this.handleDealerInvoiceDialog();
          this.props.refreshOrderDetails();
        });
    });
  };

  saveFinanceOption = (acceptedDate, type) => {
    this.props.handleUpdateOrder(type, acceptedDate);
  };

  saveRegistrationData = (number, dateFce, dateSap) => {
    this.props.updateRegistrationData(
      number,
      dateFce,
      dateSap,
      this.props.customerReservation.vinNumber,
      FINANCE
    );
    this.handleRegistrationNumberDialog();
  };

  render() {
    this.checkHasCompletedPreviousActions();
    return (
      <div>
        <div>
          {/*Finance contract will be for the both offline and online  approved orders*/}
          <HasPermissionTo
            perform={["financeContract:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={
              LowerCaseText(this.props.paymentType) === OFFLINEFINANCE ||
              FINANCE_OPTIONS.ONLINE_APPROVED_MARKETS.includes(
                UpperCaseText(this.props.selectedMarket)
              )
            }
            render={() => {
              return (
                <div data-testId="financeContract">
                  <div className={styles.rowContainer}>
                    <CalendarDialog
                      {...this.props}
                      id="financeContract"
                      saveCalendarDate={this.saveFinanceOption}
                      todayDate={this.props.customerReservation.todayDate}
                      type={FINANCE_OPTIONS.FINANCE_CONTRACT}
                      checkBoxText={this.props.t(
                        "PMFinanceContract.financeContract"
                      )}
                      isDisabled={
                        LowerCaseText(this.props.paymentType) === FINANCE
                          ? true
                          : this.hasCompletedFinanceContract ||
                            !this.canEditPaymentMethod
                      }
                      isChecked={this.hasCompletedFinanceContract}
                      hasMaxDate={true}
                      dialogTitle={this.props.t("PMFinanceContract.dateSigned")}
                      dialogDescription={this.props.t(
                        "PMFinanceContract.dialogDescription"
                      )}
                    />
                  </div>
                  {this.hasUploadedDealerInvoice &&
                    this.eSignedWindowDate !== null && (
                      <ItemDetails
                        date={this.eSignedWindowDate}
                        description={
                          <div className={styles.flexDiv}>
                            <span className={styles.dateText}>
                              {this.props.t(
                                "PMFinanceContract.eSignWindowOpen"
                              )}
                            </span>
                            {!this.eSignedDate && (
                              <>
                                <span className={styles.warningRed}>
                                  {this.props.t("PMFinanceContract.expiresOn")}
                                </span>
                                <span className={styles.warningRed}>
                                  {this.expiryDate}
                                </span>
                                <img src={Error} className={styles.Error} />
                              </>
                            )}
                          </div>
                        }
                      />
                    )}
                  {this.hasCompletedFinanceContract &&
                    (LowerCaseText(this.props.paymentType) === OFFLINEFINANCE ||
                      !IS_BRITAIN_MARKET(this.props.selectedMarket)) && (
                      <ItemDetails
                        date={
                          this.props.customerReservation.paymentDescription &&
                          this.props.customerReservation.paymentDescription.some(
                            (d) =>
                              d.status === "SIGNED" ||
                              d.status === "WETSIGN_OFFLINE"
                          ) &&
                          this.props.customerReservation.paymentDescription.filter(
                            (desc) => {
                              return (
                                desc.status === "SIGNED" ||
                                desc.status === "WETSIGN_OFFLINE"
                              );
                            }
                          )[0].date
                        }
                        description={
                          <>
                            <span className={styles.acceptGreen}>
                              {this.props.t("PMLeaseContract.eSigned")}
                            </span>
                            <span className={styles.detailsText}>
                              &nbsp;
                              {CapitalizeText(
                                this.props.customerReservation
                                  .contractSignedData.dealerActionUserId
                              )}
                            </span>
                          </>
                        }
                      />
                    )}
                </div>
              );
            }}
          />
          {/*Consumer down payment will be for only online approved orders*/}
          <HasPermissionTo
            perform={["financeCustomerDownPayment:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={LowerCaseText(this.props.paymentType) === FINANCE}
            render={() => {
              return (
                <div data-testId="consumerDownPayment">
                  <div className={styles.downPaymentDiv}>
                    <CheckBox
                      id="consumerDownPayment_id"
                      checked={this.hasCompletedDownPayment}
                      isDisabled={true}
                      label={this.props.t(
                        "PMCustomerDownPayment.customerDownPayment"
                      )}
                      onChange={this.handleConsumerDownPayment}
                      textClass={
                        this.hasCompletedPreviousOption(
                          "customerDownPayment"
                        ) || this.hasCompletedDownPayment
                          ? this.hasCompletedDownPayment
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />

                    {this.hasCompletedFinanceContract &&
                      !this.hasCompletedDownPayment && (
                        <CalendarDialogWithOutCheckBox
                          {...this.props}
                          id="consumerDownPayment"
                          type={FINANCE_OPTIONS.CUSTOMER_DOWN_PAYMENT}
                          saveCalenderDate={this.saveFinanceOption}
                          todayDate={this.props.customerReservation.todayDate}
                          isDisabled={!this.canEditPaymentMethod}
                          hasMaxDate={true}
                          dialogTitle={this.props.t(
                            "PMCustomerDownPayment.dialogHeader"
                          )}
                          dialogDescription={this.props.t(
                            "PMCustomerDownPayment.dialogDescription"
                          )}
                          customInput={
                            <span className={styles.paidOffText}>
                              {this.props.t(
                                "PMCustomerDownPayment.paidOffline"
                              )}
                            </span>
                          }
                        />
                      )}
                  </div>
                  {this.hasCompletedDownPayment && (
                    <ItemDetails
                      date={
                        this.props.customerReservation.downPaymentPaidData
                          .paymentDate
                      }
                      description={
                        <span className={styles.acceptGreen}>
                          {this.props.customerReservation.downPaymentPaidData &&
                          this.props.customerReservation.downPaymentPaidData
                            .dealerActionDetails &&
                          this.props.customerReservation.downPaymentPaidData
                            .dealerActionDetails.dealerAcceptedDate !== null
                            ? this.props.t(
                                "PMCustomerDownPayment.payReceivedOff"
                              )
                            : this.props.t("PMCustomerDownPayment.payReceived")}
                        </span>
                      }
                    />
                  )}
                </div>
              );
            }}
          />
          {/*Registration Number will be only for the online approved orders*/}
          <HasPermissionTo
            perform={["financeRegistrationNumber:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={LowerCaseText(this.props.paymentType) === FINANCE}
            render={() => {
              return (
                <div data-testId="registrationNumber">
                  <div className={styles.rowContainer}>
                    <CheckBox
                      id="registration_Number_id"
                      checked={this.hasCompletedRegistrationNumber}
                      isDisabled={
                        this.hasCompletedPreviousOption("registrationNumber") ||
                        this.hasCompletedRegistrationNumber ||
                        !this.canEditRegistrationNumber
                      }
                      label={this.props.t("PMRegistrationNumber.title")}
                      onChange={this.handleRegistrationNumberDialog}
                      textClass={
                        this.hasCompletedPreviousOption("registrationNumber") ||
                        this.hasCompletedRegistrationNumber ||
                        !this.canEditRegistrationNumber
                          ? this.hasCompletedRegistrationNumber
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />
                  </div>
                  {this.hasCompletedRegistrationNumber && (
                    <>
                      <ItemDetails
                        date={
                          this.props.customerReservation.registrationDetails
                            .dealerActionDate
                        }
                        description={
                          <>
                            <span className={styles.acceptGreen}>
                              {this.props.t("PMRegistrationNumber.recordedBy")}
                            </span>
                            <span className={styles.detailsText}>
                              {CapitalizeText(
                                this.props.customerReservation
                                  .registrationDetails.dealerActionUserId
                              )}
                            </span>
                          </>
                        }
                      />
                      <ItemDetails
                        description={
                          <>
                            <span className={styles.dateText}>
                              {this.props.t("PMRegistrationNumber.regNumber")}
                            </span>
                            <span className={styles.detailsText}>
                              {
                                this.props.customerReservation
                                  .registrationDetails.registrationNumber
                              }
                            </span>
                          </>
                        }
                      />
                      <ItemDetails
                        description={
                          <>
                            <span className={styles.dateText}>
                              {this.props.t(
                                "PMRegistrationNumber.dateRegistered"
                              )}
                            </span>
                            <span className={styles.detailsText}>
                              {UiDateUtils.formattedDate(
                                this.props.customerReservation
                                  .registrationDetails.registrationDate
                              )}
                            </span>
                          </>
                        }
                      />
                    </>
                  )}
                </div>
              );
            }}
          />
          {/*Upload Dealer Invoice will be only for the online approved orders*/}
          <HasPermissionTo
            perform={["financeUploadDealerInvoice:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={LowerCaseText(this.props.paymentType) === FINANCE}
            render={() => {
              return (
                <div data-testid="dealerInvoice">
                  <div className={styles.rowContainer}>
                    <CheckBox
                      id="dealer_Invoice_id"
                      checked={this.hasUploadedDealerInvoice}
                      isDisabled={
                        this.hasCompletedPreviousOption(
                          "uploadDealerInvoice"
                        ) ||
                        this.hasUploadedDealerInvoice ||
                        !this.canEditPaymentMethod
                      }
                      label={this.props.t(
                        "PMDealerInvoice.uploadDealerInvoice"
                      )}
                      onChange={this.handleDealerInvoiceDialog}
                      textClass={
                        this.hasCompletedPreviousOption(
                          "uploadDealerInvoice"
                        ) ||
                        this.hasUploadedDealerInvoice ||
                        !this.canEditPaymentMethod
                          ? this.hasUploadedDealerInvoice
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />
                    {this.hasUploadedDealerInvoice &&
                      !this.hasCompletedFinancePayment && (
                        <div
                          className={styles.updateText}
                          onClick={this.handleDealerInvoiceDialog}
                        >
                          {this.props.t("PaymentMethod.update")}
                        </div>
                      )}
                  </div>
                  {this.hasUploadedDealerInvoice && (
                    <ItemDetails
                      date={
                        this.props.customerReservation.uploadDealerInvoiceData
                          .dealerActionDate
                      }
                      description={
                        <>
                          <span className={styles.acceptGreen}>
                            {this.props.t("PMDealerInvoice.invoiceUploaded")}
                          </span>
                          <span className={styles.detailsText}>
                            {CapitalizeText(
                              this.props.customerReservation
                                .uploadDealerInvoiceData.dealerActionUserId
                            )}
                          </span>
                        </>
                      }
                    />
                  )}
                </div>
              );
            }}
          />
          {/*Finance payment will be for only online approved orders*/}
          <HasPermissionTo
            perform={["financePaymentCompletion:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={LowerCaseText(this.props.paymentType) === FINANCE}
            render={() => {
              return (
                <div data-testId="financePaymentConfirmation">
                  <div className={styles.rowContainer}>
                    <CalendarDialog
                      {...this.props}
                      id="financePaymentConfirmationId"
                      saveCalendarDate={this.saveFinanceOption}
                      type={FINANCE_OPTIONS.FINANCE_PAYMENT_CONFIRMED}
                      todayDate={this.props.customerReservation.todayDate}
                      checkBoxText={this.props.t(
                        "PMFinancePayment.financePayment"
                      )}
                      isDisabled={true}
                      isChecked={this.hasCompletedFinancePayment}
                      hasMaxDate={true}
                      dialogTitle={this.props.t(
                        "PMFinancePayment.dialogHeader"
                      )}
                      dialogDescription={this.props.t(
                        "PMFinancePayment.dialogDescription"
                      )}
                    />
                  </div>
                  {this.hasCompletedFinancePayment &&
                    (this.completedDate !== null ? (
                      <ItemDetails
                        date={this.completedDate}
                        description={
                          <span className={styles.acceptGreen}>
                            {this.props.t("PMFinancePayment.completed")}
                          </span>
                        }
                      />
                    ) : (
                      <ItemDetails
                        date={
                          this.props.customerReservation
                            .finalPaymentConfirmedData.dealerAcceptedDate
                        }
                        description={
                          <>
                            <span className={styles.acceptGreen}>
                              {this.props.t("PMFinancePayment.paymentReceived")}
                            </span>
                            <span className={styles.detailsText}>
                              {
                                this.props.customerReservation
                                  .finalPaymentConfirmedData.dealerActionUserId
                              }
                            </span>
                          </>
                        }
                      />
                    ))}
                </div>
              );
            }}
          />
        </div>
        <RegistrationNumberDialog
          {...this.props}
          open={this.state.openRegistrationNumberDialog}
          close={this.handleRegistrationNumberDialog}
          saveRegistrationData={this.saveRegistrationData}
          maxDate={UiDateUtils.addMonths(6)}
          minDate={UiDateUtils.addDays(-60)}
          fromNscDealerSearch={this.props.fromNscDealerSearch}
        />
        <TermsDialog
          open={this.state.openDealerInvoiceDialog}
          forAll={false}
          dialogBody={this.props.t("PMDealerInvoice.dialogDescription")}
          dialogTitle={this.props.t("PMDealerInvoice.dialogHeader")}
          saveText={this.props.t("PMDealerInvoice.upload")}
          currentDealerId="this.selectedDealer"
          confirmAction={this.uploadInvoice}
          onClose={this.handleDealerInvoiceDialog}
        />
      </div>
    );
  }
}

export default withTranslation("emp")(FinanceOptions);
